import CompanyAvatar from 'components/CompanyAvatar';
import { useAuthenticatedContext } from 'hooks/useAuthenticated';

import * as Styled from './UserWidget.styles';

const UserWidget = () => {
  const { currentUser } = useAuthenticatedContext();

  if (!currentUser) {
    return null;
  }

  return (
    <Styled.UserWidget color={currentUser.color}>
      <Styled.UserName>
        <Styled.Name>{`${currentUser.firstName} ${currentUser.lastName}`}</Styled.Name>
        <Styled.CompanyName color={currentUser.color}>{currentUser.name}</Styled.CompanyName>
      </Styled.UserName>
      <CompanyAvatar color={currentUser.color} Icon={currentUser.Icon} />
    </Styled.UserWidget>
  );
};

export default UserWidget;
